import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import {
  Header,
  ProductDescription,
  SavingsCard,
  Footer,
  Button,
  Container,
  Font51,
  Font20,
  ContainerTitle,
  ContainerSubTitle,
  Input,
  CarouselComponent,
  BodyWrapper,
  MobileFooter
} from '../components'
import { withRouter } from 'react-router-dom'
import SecondaryHeader from '../components/SecondaryHeader'
import { Element } from 'react-scroll'
import clientBackgound from '../static/client-background.png'
import demoVideoLappy from '../static/extact-lappy.jpg'

// const scroll = Scroll.animateScroll

const TopImageWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  z-index: -1;
  & > img {
    width: 340px;
    position: absolute;
    z-index: -1;
    object-fit: contain;
  }
  @media (max-width: 768px) {
    display: none;
  }
`
const TopContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 105px 80px 0px 80px;
  max-width: 1366px;
  margin: 0 auto;
  & > div:nth-child(1) {
    max-width: 700px;
    width: 55%;
    margin: 0 auto;
    & > h1 {
      font-size: 48px;
      line-height: 1.33;
      letter-spacing: -0.5px;
      color: #000000;
    }
    & > p:nth-child(2) {
      font-size: 18px;
      line-height: 1.61;
      letter-spacing: -0.2px;
      padding: 17px 0;
      max-width: 450px;
      & > span {
        color: #4192ec;
        cursor: pointer;
      }
    }
    & > p:nth-child(3) {
      font-size: 12px;
      line-height: normal;
      color: #4da1ff;
      padding: 20px 0 7px 0px;
      @media (max-width: 768px) {
        display: none;
      }
    }
  }
  & > div:last-child {
    width: 45%;
    & > img {
      padding-top: 50px;
      height: auto;
      object-fit: cover;
      width: 100%;
      object-fit: cover;
      transform: scale(1.3);
      position: relative;
    }
  }

  @media (max-width: 992px) {
    padding: 80px 20px 20px 20px;

    & > div > h1 {
      font-size: 38px !important;
    }
    & p {
      font-size: 16px !important;
    }
    & img {
      transform: scale(1) !important;
    }
  }

  @media (max-width: 768px) {
    padding: 30px 20px 20px 20px;
    & > div {
      &:first-child {
        width: 100%;
      }
      &:last-child {
        display: none;
      }
      > h1 {
        font-size: 28px !important;
      }
      & p {
        font-size: 16px !important;
      }
      & img {
        transform: scale(1) !important;
      }
    }
  }
`

const FormWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 53px;
  & > input {
    width: 290px;
    height: 53px;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0.1px;
    border-radius: 4px 0 0 4px;
    padding: 17px 0 15px 15px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05), 0 6px 12px 0 rgba(0, 0, 0, 0.05);
    border: solid 0.5px rgba(0, 0, 0, 0.05);
    :focus {
      outline: none;
    }
    ::placeholder {
      /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: #666666;
      opacity: 1; /* Firefox */
    }

    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #666666;
    }

    ::-ms-input-placeholder {
      /* Microsoft Edge */
      color: #666666;
    }
  }
  & > button {
    border-radius: 0 4px 4px 0;
  }

  @media (max-width: 768px) {
    display: block;
    & > input {
      width: 100%;
      height: 38px;
      padding: 10px 15px;
    }
    & button {
      margin-top: 10px;
      width: 100%;
      border-radius: 4px;
    }
  }
`

const ImageLeftWrapper = styled.div`
  bottom: 0px;
  position: absolute;
  left: 0px;
  z-index: -1;
  & > img {
    position: absolute;
    width: 100px;
    object-fit: contain;
    left: 0px;
    top: -50px;
  }
  @media (max-width: 768px) {
    display: none;
  }
`

const ProductCards = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  max-width: 1366px;
  @media (max-width: 768px) {
    & > div {
      width: 100%;
      margin: 0px auto;
    }
  }
`

const WorkingWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 100px 80px 80px;
  max-width: 1366px;
  margin: 0 auto;
  background: #fafbfc;
  & > div {
    max-width: calc(50% - 20px);
  }
  & > div:nth-child(1) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    & > p:nth-child(1) {
      font-size: 38px;
      font-weight: normal;
      line-height: 1.21;
      color: #333333;
      margin: 0;
    }
    & > p:nth-child(2) {
      font-size: 16px;
      font-weight: normal;
      line-height: 1.63;
      letter-spacing: 0.1px;
      color: #999;
      padding: 20px 0;
    }
  }
  & > div:nth-child(2) {
    margin-left: 64px;
    & > div:last-child {
      & > div > div {
        display: none;
      }
    }
  }

  @media (max-width: 992px) {
    padding: 50px 20px 50px;
    & > div:nth-child(2) {
      margin-left: 30px;
    }
  }

  @media (max-width: 768px) {
    display: block;
    & > div:nth-child(2) {
      margin-left: 0px;
    }

    & > div {
      width: 100%;
      max-width: 100%;
    }

    & > :first-child {
      text-align: center;
      display: block !important;
      padding-bottom: 40px;
      & > p:nth-child(1) {
        font-size: 28px !important;
      }
    }
  }
`
const BigImage = styled.div`
  max-width: 980px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  & > div {
    position: relative;
    padding-top: 25px;
    padding-bottom: 67.5%;
    height: 0;
    & > iframe {
      box-sizing: border-box;
      background-image: url(${demoVideoLappy});
      background-position: center center;
      background-repeat: no-repeat;
      background-size: contain;
      padding: 12.4% 15.4% 15.4%;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  @media (max-width: 540px) {
  }
  width: 100%;
  & img {
    max-width: 100%;
  }
`
const Block = styled.div`
  display: flex;
`
const Left = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-right: 64px;
  & > img {
    width: 50px;
    object-fit: contain;
  }
  @media (max-width: 992px) {
    padding-right: 25px;
  }
}
`
const Right = styled.div`
  & > p:first-child {
    font-size: 22px;
    line-height: 1.45;
    letter-spacing: normal;
    color: #333333;
  }
  & > p:last-child {
    font-size: 16px;
    line-height: 1.63;
    letter-spacing: 0.1px;
    color: #999999;
    padding: 10px 0 30px;
  }
  @media (max-width: 992px) {
    & > p:first-child {
      font-size: 20px;
    }
  }
`
const VerticalLine = styled.div`
  width: 1px;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  margin: 24px;
`

const SubscriptionWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 980px;
  padding : 100px 0px 40px 0px;
  &>div:nth-child(1){
    width: calc(60% - 0px);
    padding-right: 20px;
  }
  }
  &>div:nth-child(2){
    width: calc(40% - 0px);
    padding-left: 20px;
    @media (max-width: 768px) {
      padding-left: 0;
      width: calc(100% - 0px);
    }
  }
  & > div:nth-child(1) {
    & > p:nth-child(1){
      font-size: 28px;
      font-weight: normal;
      line-height: 1.64;
      letter-spacing: -0.4px;
      color: #333333;
    }
    & > p:nth-child(2){
      font-size: 19px;
      font-weight: 300;
      line-height: 1.53;
      color: #999999;
      @media (max-width: 768px) {
        font-size: 16px;
        padding: 10px 0 30px 0;
      }
    }
    }
  }
  @media (max-width: 768px) {
    display: block;
    padding-top: 20px;
    &>div:nth-child(1){
      width: calc(100% - 0px);
      padding-right: 0;
    }
    }
  }
`

const Form = styled.div`
  display: flex;
  flex-direction: column;
  & > div {
    margin-bottom: 20px;
    & > input {
      font-family: Montserrat;
      font-size: 14px;
      font-weight: normal;
      line-height: normal;
      letter-spacing: 0.1px;
      width: 100%;
      background: transparent;
      border-radius: 4px;
      border: 1px solid rgba(5, 5, 5, 0.1);
      ::placeholder {
        /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #666666;
        opacity: 1; /* Firefox */
      }

      :-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #666666;
      }

      ::-ms-input-placeholder {
        /* Microsoft Edge */
        color: #666666;
      }
    }
  }

  & > button {
    width: 100%;
    font-size: 20px;
    line-height: normal;
    letter-spacing: normal;
    color: #ffffff;
  }
`
const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 33%;
  margin: 0 auto;
  position: relative;
`
const Save = styled.div`
  position: absolute;
  z-index: 0;
  top: 12px;
  min-width: 84px;
  height: 24px;
  border-radius: 2px;
  text-transform: capitalize;
  background-color: #f0425f;
  font-size: 15px;
  line-height: 1.33;
  letter-spacing: 0.4px;
  color: #ffffff;
  text-align: center;
  padding: 2px 8px;
  align-self: flex-start;
  left: -10px;
  &:before {
    left: 4.9px;
    top: 19px;
    content: '';
    position: absolute;
    border-left: solid 7.3px #9e1e33;
    border-bottom: solid 7.3px transparent;
    border-top: solid 7.3px transparent;
    transform: rotate(-45deg);
  }
`
const OuterWrapper = styled.div`
  display: flex;
  justify-content: center;
  max-width: 980px;
  width: 100%;
  padding-top: 60px;
  & > div:nth-child(2) {
    margin: 0 20px;
  }
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  @media (max-width: 768px) {
    display: block;
    & > div:nth-child(2) {
      margin: 0;
    }
    & > div {
      padding-bottom: 60px;
      width: 100%;
    }
  }
`

const CarouselWrapper = styled.div`
  height: ${props => (props.height ? props.height : '550px')};
  @media (max-width: 640px) {
    height: auto;
  }
`

const PriceWrapper = styled.div`
  background: rgb(250, 251, 252);
`
const ClientsContainer = styled.section`
  padding-top: 80px;
  background-size: cover;
  background-position: 0 -40px;
  padding-bottom: 40px;
  background-image: url(${clientBackgound});
  @media (max-width: 640px) {
    padding-top: 40px;
  }
`

const HomeWrapper = styled.div`
  position: relative;
`
class Extract extends Component {
  render() {
    return (
      <Fragment>
        <Header type="product" />
        <SecondaryHeader />
        <Element name="overview">
          <HomeWrapper>
            <TopImageWrapper>
              <img src={require('../static/rectangle2.png')} alt="rectangle" />
            </TopImageWrapper>
            <TopContentWrapper>
              <div>
                <h1>Developer-friendly tool to host efficient scrapers</h1>
                <p>
                  A cloud-based web extraction platform, allows users to easily extract data from web pages. It provides
                  easy to integrate and high quality data from zillion sources.
                </p>
                <p>EMAIL</p>
                <form action="https://formspree.io/harsh@8om.io" method="POST">
                  <FormWrapper>
                    <input type="email" name="_replyto" placeholder="your@email.com" required />
                    <input type="hidden" name="_next" value="/" />
                    <Button
                      type="submit"
                      title="Submit"
                      background="#4da1ff"
                      width="160"
                      height="53"
                      transform="capitalize"
                    />
                  </FormWrapper>
                </form>
              </div>
              <div>
                <img src={require('../static/extract_demo.png')} alt="laptop" />
              </div>
            </TopContentWrapper>
            <ImageLeftWrapper>
              <img src={require('../static/rectangle1.png')} alt="rectangle" />
            </ImageLeftWrapper>
          </HomeWrapper>
        </Element>
        <Element name="features">
          <Container padding={'150px 80px 50px 80px'} background="transparent">
            <Font51>Built to customize your projects </Font51>
            <Font20>Minimise your efforts of extracting data as extract takes care of below.</Font20>
            <ProductCards>
              <ProductDescription
                icon={'multiple_crawlers.svg'}
                title="Multiple Crawlers"
                description="One-click deployment of multiple crawlers."
              />
              <ProductDescription
                icon={'scheduler.svg'}
                title="Scheduled Crawls"
                description="Either run once or schedule your crawlers for complete automation."
              />
              <ProductDescription
                icon={'logging.svg'}
                title="Logging"
                description="Easily check and download logs for all your jobs."
              />
              <ProductDescription
                icon={'complete_control.svg'}
                title="Complete Control"
                description="Control your crawlers with simple clicks. Pause, Stop, Kill, Start anytime!"
              />
              <ProductDescription
                icon={'download_data.svg'}
                title="Download Data"
                description="Once your crawl job is finished, download the data crawled in the process."
              />
              <ProductDescription
                icon={'easy_upload.svg'}
                title="Easy Upload"
                description="Add your crawler via zip or github connection while creating your project."
              />
            </ProductCards>
          </Container>
        </Element>
        <Element name="howItWorks" style={{ background: '#fafbfc' }}>
          <WorkingWrapper>
            <div>
              <p>How it works?</p>
              <p>
                The process for using Extract is very simple. Sign up online for the free trial initially and you can
                start getting vast data which is significant for your business within no time on your system in a
                spreadsheet format.
              </p>
            </div>
            <div>
              <Block>
                <Left>
                  <img src={require('../static/add_project.svg')} alt="strategy" />
                  <VerticalLine />
                </Left>
                <Right>
                  <p>Add Project</p>
                  <p>Enter all the required details for the project you need to have the data for.</p>
                </Right>
              </Block>
              <Block>
                <Left>
                  <img src={require('../static/deploy_code.svg')} alt="strategy" />
                  <VerticalLine />
                </Left>
                <Right>
                  <p>Deploy Code</p>
                  <p>Now start with coding or build spiders and deploy them to the cloud.</p>
                </Right>
              </Block>
              <Block>
                <Left>
                  <img src={require('../static/assign_task.svg')} alt="strategy" />
                  <VerticalLine />
                </Left>
                <Right>
                  <p>Assign Task</p>
                  <p>You can easily manage spiders and assign them to run the task accordingly.</p>
                </Right>
              </Block>
              <Block>
                <Left>
                  <img src={require('../static/monitor_tasks.svg')} alt="strategy" />
                  <VerticalLine />
                </Left>
                <Right>
                  <p>Monitor Tasks</p>
                  <p>
                    Review and monitor the tasks running anytime you want. You can also filter, analyse and aggregate
                    data.
                  </p>
                </Right>
              </Block>
              <Block>
                <Left>
                  <img src={require('../static/download.svg')} alt="strategy" />
                  <VerticalLine />
                </Left>
                <Right>
                  <p>Download Data</p>
                  <p>Download the data extracted in CSV, JSON or XML formats.</p>
                </Right>
              </Block>
              <Block>
                <Left>
                  <img src={require('../static/get_started.svg')} alt="strategy" />
                  <VerticalLine />
                </Left>
                <Right>
                  <p>Get Started</p>
                  <p>You have the data and are good to go.</p>
                </Right>
              </Block>
            </div>
          </WorkingWrapper>
        </Element>
        <Container>
          <ContainerTitle>Product Demo</ContainerTitle>
          <ContainerSubTitle>
            Here we provide a short demo of extract to make it even more simple and understandable for its users.
          </ContainerSubTitle>
          <BigImage>
            <div>
              <iframe
                title="extract video"
                width="806"
                height="436"
                src="https://drive.google.com/file/d/1N9-eGa6SVawOhVDx5669PLa4C21ccNZB/preview"
                version="3"
                frameborder="0"
                allow="autoplay; encrypted-media"
                allowfullscreen
              />
            </div>
          </BigImage>
        </Container>
        <Element name="pricing">
          <PriceWrapper>
            <Container background="rgb(250, 251, 252)">
              <ContainerTitle>Know how much you SAVE</ContainerTitle>
              <OuterWrapper>
                <CardWrapper>
                  <SavingsCard
                    support="Support over forum and email."
                    ipRotation={'Single IP'}
                    dataRetention={'7'}
                    core={'Single'}
                    ram={'Up to 1GB RAM'}
                    savingImage="trial"
                    plan="TRIAL"
                    subTitle="/monthly"
                    server="Shared"
                    storage="Shared"
                    projects="1"
                    tasks="5 Tasks"
                    schedulers="1"
                    trial={true}
                    cost={'Cost Free Forever'}
                  />
                  <a href="https://extract.8om.io/login" target="_blank" rel="noopener noreferrer">
                    <Button
                      transform="capitalize"
                      type="submit"
                      title="Get Started"
                      background="#4da1ff"
                      width="180"
                      height="42"
                      shadow={'0 2px 4px 0 rgba(0, 0, 0, 0.5)'}
                    />
                  </a>
                </CardWrapper>
                <CardWrapper>
                  <Save>SAVE 20%</Save>
                  <SavingsCard
                    support="Chat Support"
                    ipRotation={'Single IP'}
                    dataRetention={'7'}
                    subTitle="/monthly"
                    core={'Single'}
                    ram={'Up to 1GB RAM'}
                    savingImage="basic"
                    plan="BASIC"
                    number="19"
                    server="Shared"
                    storage="Shared"
                    projects="5"
                    tasks="50 Tasks"
                    schedulers="5"
                    cost={'Excluding Tax'}
                  />
                  <Link to="/contact">
                    <Button
                      transform="capitalize"
                      type="submit"
                      title="Request a quote"
                      background="#4da1ff"
                      width="180"
                      height="43"
                      shadow={'0 2px 4px 0 rgba(0, 0, 0, 0.5)'}
                    />
                  </Link>
                </CardWrapper>
                <CardWrapper>
                  <SavingsCard
                    support="Priority Support"
                    ipRotation={'IP Rotation (5 IPs)'}
                    dataRetention={'30'}
                    core={'More than 1'}
                    ram={'More than 1 GB RAM'}
                    savingImage="premium"
                    plan="PREMIUM"
                    subTitle="/monthly"
                    number="49"
                    server="Dedicated"
                    storage="Multiple"
                    projects="Unlimited"
                    tasks="Unlimited Tasks /Mo"
                    schedulers="Unlimited"
                    cost={'Excluding Tax'}
                  />

                  <Link to="/contact">
                    <Button
                      transform="capitalize"
                      type="submit"
                      title="Request a quote"
                      background="#4da1ff"
                      width="180"
                      height="43"
                      shadow={'0 2px 4px 0 rgba(0, 0, 0, 0.5)'}
                    />
                  </Link>
                </CardWrapper>
              </OuterWrapper>
              <SubscriptionWrapper>
                <div>
                  <p>Still not satisfied with the subscription plans Contact Us</p>
                  <p>
                    We know every user is different and so are their needs. We are here always to serve their needs. Let
                    us know if you have any issue and we are on it. If still not satisfied with the subscription plans
                    Contact Us
                  </p>
                </div>
                <form action="https://formspree.io/harsh@8om.io" method="POST">
                  <Form>
                    <Input type="text" name="name" placeholder="Your name" icon={'user'} changeColor={'#2196f3'} />
                    <Input type="text" name="contact" placeholder="Contact" icon={'contact'} changeColor={'#2196f3'} />
                    <Input
                      type="email"
                      name="_replyto"
                      placeholder="your@email.com"
                      icon={'email'}
                      changeColor={'#2196f3'}
                    />
                    <input type="hidden" name="_next" value="/" />
                    <Button
                      title="Send Request"
                      transform="capitalize"
                      type="submit"
                      background="#4da1ff"
                      width="180"
                      height="53"
                      shadow={'0 2px 4px 0 rgba(0, 0, 0, 0.5)'}
                    />
                  </Form>
                </form>
              </SubscriptionWrapper>
            </Container>
          </PriceWrapper>
        </Element>
        <ClientsContainer>
          <ContainerTitle>Our Clients</ContainerTitle>
          <CarouselWrapper height={'400px'}>
            <CarouselComponent carouselType="extract" />
          </CarouselWrapper>
        </ClientsContainer>
        <BodyWrapper>
          <Footer />
          <MobileFooter />
        </BodyWrapper>
      </Fragment>
    )
  }
}

export default withRouter(Extract)



// WEBPACK FOOTER //
// ./src/pages/Extract.js